// extracted by css-extract-rspack-plugin
export default {"container":"_45c4408a","text":"_7eea2d0"};